<template>
  <check-form :formId="formId"></check-form>
</template>

<script>
  import CheckForm from '../../CheckForm'
  export default {
    name: 'VoiceItem2',
    components: { CheckForm },
    props:{
      formId:{
        type:String,
        default:''
      }
    }
  }
</script>

<style scoped>

</style>